export default __webpack_public_path__ + "static/media/gmovers.d365dc98.gif";